import { MouseEvent, PropsWithChildren, ReactNode } from 'react';
import { IUIComponentProps } from '../../types';
import { IResponsiveImageSource } from '../Image';
import { isRelativeUrl } from '../Link';
import {
	StyledCardChildren,
	StyledCardContent,
	StyledCardLink,
	StyledCardPicture,
	StyledCardTitle,
	withCardContainerContext,
} from '../Card';

import { StyledContactCard } from './StyledContactCard';
import { StyledContactCardPhoneNumber } from './StyledContactCardPhoneNumber';
import { StyledContactCardPhoneLink } from './StyledContactCardPhoneLink';
import { PhoneIcon } from '../Icon';

export interface IContactCardProps
	extends PropsWithChildren<IUIComponentProps> {
	title: string;
	screenReaderLinkTitle?: string;
	phoneNumber?: string;
	imageSource: IResponsiveImageSource | ReactNode;
	imageAlt?: string;
	linkHref?: string;
	linkTitle?: string;
	onClick?: (e: MouseEvent<HTMLLIElement>) => void;
	phoneImageLabel?: string;
}

export const ContactCard = withCardContainerContext<IContactCardProps>(
	({
		title,
		phoneNumber,
		imageSource,
		imageAlt,
		children,
		linkHref,
		linkTitle,
		screenReaderLinkTitle,
		phoneImageLabel,
		...rest
	}) => (
		<StyledContactCard {...rest}>
			<StyledCardPicture source={imageSource} alt={imageAlt} />
			<StyledCardContent>
				<div>
					<StyledCardTitle styling="h3">{title}</StyledCardTitle>
					<StyledCardChildren>{children}</StyledCardChildren>
					{phoneNumber && (
						<StyledContactCardPhoneNumber>
							{phoneNumber}
						</StyledContactCardPhoneNumber>
					)}
					{linkHref && linkTitle && (
						<StyledCardLink
							href={linkHref}
							target={!isRelativeUrl(linkHref) ? '_blank' : undefined}
							screenReaderTitle={screenReaderLinkTitle}
						>
							{linkTitle}
						</StyledCardLink>
					)}
				</div>
				{phoneNumber && (
					<StyledContactCardPhoneLink href={`tel:${phoneNumber}`}>
						<PhoneIcon aria-hidden />
					</StyledContactCardPhoneLink>
				)}
			</StyledCardContent>
		</StyledContactCard>
	),
);
